/*
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-12-28 10:36:19
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-12-28 17:07:20
 * @FilePath: /chaoyongtuan/src/views/secondColonelManage/cooperativeColonel/list/columns.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import ColumnTypes from '@/utils/ColumnTypes';

function getColumns() {
	let arr = [
		{
			label: '团长信息',
			minWidth: '196',
            type: () => import('./components/tableCell/leaderInfo.vue'),
		},
        {  
            key: 'order_anchor_num',
            tableKey: 'productPayCount',
			label: '出单商品',
			minWidth: '100',
			sortable: 'order_anchor_num',
            type: () => import('./components/tableCell/tableCount.vue'),
		},
        {
            key: 'order_product_num',
            tableKey: 'anchorPayCount',
			label: '出单达人',
			minWidth: '100',
			sortable: 'order_product_num',
            type: () => import('./components/tableCell/tableCount.vue'),
		},
        {
            label: '寄样次数',
            tableKey: 'productSendSampleNum',
            minWidth: '80',
            type: () => import('./components/tableCell/tableCount.vue'),
        },
        {
            label: '寄样出单率',
            minWidth: '100',
            type: () => import('./components/tableCell/tableRate.vue'),
        },
        {
            key: 'sale_amount',
            label: '销售额',
            minWidth: '120',
            sortable: 'sale_amount',
            tableKey: 'payOrderGmv',
            type: () => import('./components/tableCell/tableCount.vue'),
        },
        {
            label: '预估到手服务费',
            minWidth: '120',
            tableKey: 'estimateServiceAmount',
            type: () => import('./components/tableCell/tableCount.vue'),
        },
        {
            label: '跟进信息',
            minWidth: '120',
            type: () => import('./components/tableCell/followInfo.vue'),
        },
        {
            label: '操作',
            key: 'operations',
            type: ColumnTypes.ButtonsCell,
            width: '100',
        }
	];
	return arr;
}

export default getColumns;
